import React from 'react';
import { useSelector } from 'react-redux';
import { FaArrowRight, FaTools } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicesCard from '../../components/home/ServicesCard';
import RentalTerms from '../../components/services/Services';
import './Equimentrental.css';
import { useNavigate } from 'react-router-dom';
import FaqSection from '../../components/about/FAQ';
import ServicesRent from '../../components/services/ServicesRent';

const GeneralContracting = () => {
  const { language } = useSelector((state) => state.language);
  const navigate = useNavigate();
  const translations = {
    gb: {
      heroContent: {
        title: 'Equipment Rental',
        subtitle: 'Services',
        description: 'Get the right equipment for your job – on time, every time. Professional-grade machinery with flexible rental terms.',
        buttonText: 'Get in Touch',
      },
      categories: {
        title: 'Equipment Categories',
        description: 'From heavy machinery to specialized tools, we have everything you need to complete your project successfully.',
      },
      serviceCards: {
        heavyEquipment: 'Heavy Equipment',
        lightEquipment: 'Light Equipment',
      },
    },
    sa: {
      heroContent: {
        title: 'تأجير المعدات',
        subtitle: 'الخدمات',
        description: 'احصل على المعدات المناسبة لعملك - في الوقت المحدد، في كل مرة. معدات احترافية مع شروط تأجير مرنة.',
        buttonText: 'تواصل معنا',
      },
      categories: {
        title: 'فئات المعدات',
        description: 'من الآلات الثقيلة إلى الأدوات المتخصصة، لدينا كل ما تحتاجه لإكمال مشروعك بنجاح.',
      },
      serviceCards: {
        heavyEquipment: 'المعدات الثقيلة',
        lightEquipment: 'المعدات الخفيفة',
      },
    },
    fr: {
      heroContent: {
        title: 'Location d’équipement',
        subtitle: 'Services',
        description: 'Obtenez l’équipement adapté à votre projet – à temps, à chaque fois. Machines de qualité professionnelle avec des conditions de location flexibles.',
        buttonText: 'Contactez-nous',
      },
      categories: {
        title: 'Catégories d’équipement',
        description: 'Des machines lourdes aux outils spécialisés, nous avons tout ce dont vous avez besoin pour mener à bien votre projet.',
      },
      serviceCards: {
        heavyEquipment: 'Équipement lourd',
        lightEquipment: 'Équipement léger',
      },
    },
    de: {
      heroContent: {
        title: 'Gerätevermietung',
        subtitle: 'Dienstleistungen',
        description: 'Holen Sie sich die richtigen Geräte für Ihren Auftrag – pünktlich, jedes Mal. Professionelle Maschinen mit flexiblen Mietbedingungen.',
        buttonText: 'Kontaktieren Sie uns',
      },
      categories: {
        title: 'Gerätekategorien',
        description: 'Von schweren Maschinen bis zu spezialisierten Werkzeugen – wir haben alles, was Sie benötigen, um Ihr Projekt erfolgreich abzuschließen.',
      },
      serviceCards: {
        heavyEquipment: 'Schwere Geräte',
        lightEquipment: 'Leichte Geräte',
      },
    },
  };

  const t = translations[language] || translations.gb;

  return (
    <>
      <section
        className="equipment-rental-hero py-5"
        style={{ background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)' }}
      >
        <div className="container h-100 px-3">
          <div className="row justify-content-center align-items-center text-center h-100">
            <div className="col-md-8">
              <FaTools className="me-3 text-danger" size={30} />
              <h1 className="mb-3 fw-bold display-4 display-md-3 display-lg-2">
                {t.heroContent.title}
                <div className="d-flex justify-content-center mt-2">
                  <div
                    style={{
                      width: '40px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                    }}
                  ></div>
                  <div
                    style={{
                      width: '5px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                      margin: '0 4px',
                    }}
                  ></div>
                  <div
                    style={{
                      width: '40px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                    }}
                  ></div>
                </div>
              </h1>
              <h3 className="mb-4" style={{ color: '#EF4444' }}>
                {t.heroContent.subtitle}
              </h3>
              <p className="mb-4" style={{ color: '#000' }}>
                {t.heroContent.description}
              </p>
              <button
                className="btn btn-primary mt-3 btn-hover mb-5"
                style={{
                  backgroundColor: '#B91C1C',
                  borderRadius: '50px',
                  color: 'white',
                  padding: '10px 30px',
                  border: '0',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
                onClick={() => navigate('/contact')}
              >
                {t.heroContent.buttonText}
                <FaArrowRight className="btn-arrow" />
              </button>
            </div>
          </div>
        </div>

        {/* Add hover styles */}
        <style>{`
          .btn-hover:hover .btn-arrow {
            transform: translateX(3px);
          }
          .btn-hover:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
          }
        `}</style>
      </section>

      <section className="equipment-categories py-5">
        <div className="container px-3">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1 className="fw-bold display-4 display-md-3 display-lg-2 mb-4">
                {t.categories.title}
                <div className="d-flex justify-content-center mt-2">
                  <div
                    style={{
                      width: '40px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                    }}
                  ></div>
                  <div
                    style={{
                      width: '5px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                      margin: '0 4px',
                    }}
                  ></div>
                  <div
                    style={{
                      width: '40px',
                      height: '3px',
                      backgroundColor: '#c8102e',
                    }}
                  ></div>
                </div>
              </h1>
              <p className="mb-4" style={{ color: '#4B5563' }}>
                {t.categories.description}
              </p>
            </div>
          </div>
        </div>
      </section>

      <ServicesCard headingText={t.serviceCards.heavyEquipment} showParagraph={false} />
      <ServicesCard headingText={t.serviceCards.lightEquipment} showParagraph={false} />

      <RentalTerms />

      <ServicesRent />

      <FaqSection />
    </>
  );
};

export default GeneralContracting;